import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import HomePage from "./pages/HomePage";
import AuthPage from "./pages/AuthPage";
import AuthCallback from "./pages/AuthCallback";
import Dashboard from "./pages/Dashboard";
import VitaAI from "./pages/VitaAI";
import Community from "./pages/Community";
import Marketplace from "./pages/Marketplace";
import Pricing from "./pages/Pricing";
import PaymentSuccess from "./pages/PaymentSuccess";
import Messages from "./pages/Messages";
import Challenges from "./pages/Challenges";
import GoalProgress from "./pages/Progress";
import Reminders from "./pages/Reminders";
import AdminPanel from "./pages/AdminPanel";
import Groups from "./pages/Groups";
import VitaCoach from "./pages/VitaCoach";

function AppRouter() {
  const location = useLocation();

  // Check URL fragment for session_id synchronously during render
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/auth" element={<AuthPage />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/vita-ai" element={<VitaAI />} />
      <Route path="/community" element={<Community />} />
      <Route path="/marketplace" element={<Marketplace />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/payment-success" element={<PaymentSuccess />} />
      <Route path="/messages" element={<Messages />} />
      <Route path="/challenges" element={<Challenges />} />
      <Route path="/progress" element={<GoalProgress />} />
      <Route path="/reminders" element={<Reminders />} />
      <Route path="/admin" element={<AdminPanel />} />
      <Route path="/groups" element={<Groups />} />
      <Route path="/vita-coach" element={<VitaCoach />} />
    </Routes>
  );
}

import { useEffect } from "react";

function App() {
  useEffect(() => {
    const remove = () => { const b = document.getElementById('emergent-badge'); if (b) b.remove(); };
    remove();
    const id = setInterval(remove, 500);
    return () => clearInterval(id);
  }, []);

  return (
    <BrowserRouter>
      <AppRouter />
      <Toaster position="bottom-right" />
    </BrowserRouter>
  );
}

export default App;
